import { render, staticRenderFns } from "./addGifeCode.vue?vue&type=template&id=63d39c0e&scoped=true&"
import script from "./addGifeCode.vue?vue&type=script&lang=js&"
export * from "./addGifeCode.vue?vue&type=script&lang=js&"
import style0 from "./addGifeCode.vue?vue&type=style&index=0&id=63d39c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d39c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d39c0e')) {
      api.createRecord('63d39c0e', component.options)
    } else {
      api.reload('63d39c0e', component.options)
    }
    module.hot.accept("./addGifeCode.vue?vue&type=template&id=63d39c0e&scoped=true&", function () {
      api.rerender('63d39c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/giftCodeManage/giftCode/component/addGifeCode.vue"
export default component.exports